import { h } from 'preact';
import { Text } from 'preact-i18n';
import IconListItem from '../icon-list-item';
import LocationsList from '../locations-list';
import FavoritesCounter from '../favorites-counter';
import cx from 'classnames';
import style from './style.less';

export default function FavoriteLocations({ locations = [], maxFavorites, onDismissFavorite, onSetCurrent, ...props }) {
	let header = ([
		<Text id="favoritesHeader" />,
		' ',
		<FavoritesCounter numFavorites={locations.length} maxFavorites={maxFavorites} />
	]);
	return (
		<LocationsList {...props} class={cx(style.favorites, props.class)} header={header} headerIcon="star-cube">
			{locations.map((location) => (
				<IconListItem
					location={location}
					class={style.focusTrash}
					icon="close-cube"
					onClickLocation={onSetCurrent}
					onClickIcon={onDismissFavorite}
				/>
			))}
		</LocationsList>
	);
}



// WEBPACK FOOTER //
// ../node_modules/@cube/location-widget/src/components/favorite-locations/index.js